// Catálogos espejo del módulo Fideicomiso de Garantía (Fase 1A) — backend/fideicomisos.py

export const ESTADOS_FID = {
  prospecto: { label: "Prospecto", cls: "bg-slate-100 text-slate-700" },
  en_integracion: { label: "En integración", cls: "bg-blue-100 text-blue-700" },
  constituido: { label: "Constituido", cls: "bg-indigo-100 text-indigo-700" },
  vigente: { label: "Vigente", cls: "bg-emerald-100 text-emerald-700" },
  en_ejecucion: { label: "En ejecución", cls: "bg-amber-100 text-amber-700" },
  extinguido: { label: "Extinguido", cls: "bg-slate-200 text-slate-600" },
  revertido: { label: "Revertido", cls: "bg-red-100 text-red-700" },
};

export const ROLES_PARTE = [
  { value: "fideicomitente", label: "Fideicomitente" },
  { value: "fideicomitente_adherente", label: "Fideicomitente adherente" },
  { value: "fideicomisario_primer_lugar", label: "Fideicomisario en primer lugar" },
  { value: "fideicomisario_segundo_lugar", label: "Fideicomisario en segundo lugar" },
  { value: "ejecutor_independiente", label: "Ejecutor independiente (Art. 395)" },
  { value: "delegado_fiduciario", label: "Delegado fiduciario" },
  { value: "miembro_comite_tecnico", label: "Miembro del comité técnico" },
];
export const ROL_PARTE_LABEL = Object.fromEntries(ROLES_PARTE.map((r) => [r.value, r.label]));
export const ROLES_FIDEICOMISARIO = ["fideicomisario_primer_lugar", "fideicomisario_segundo_lugar"];
export const ROLES_FIDEICOMITENTE = ["fideicomitente", "fideicomitente_adherente"];

export const CAUSAS_EXTINCION = [
  { value: "realizacion_fin", label: "Realización del fin (Art. 392-I)" },
  { value: "imposibilidad", label: "Imposibilidad de realizarlo (Art. 392-II)" },
  { value: "condicion_suspensiva", label: "Condición suspensiva no cumplida (Art. 392-III)" },
  { value: "condicion_resolutoria", label: "Condición resolutoria cumplida (Art. 392-IV)" },
  { value: "convenio_partes", label: "Convenio entre las partes (Art. 392-V)" },
  { value: "revocacion", label: "Revocación del fideicomitente (Art. 392-VI)" },
  { value: "otro", label: "Otra causa" },
];

export const ESTADO_CIVIL_OPTIONS = [
  { value: "soltero", label: "Soltero(a)" },
  { value: "casado_sociedad_conyugal", label: "Casado(a) — sociedad conyugal" },
  { value: "casado_separacion_bienes", label: "Casado(a) — separación de bienes" },
  { value: "union_libre", label: "Unión libre" },
  { value: "viudo", label: "Viudo(a)" },
  { value: "divorciado", label: "Divorciado(a)" },
];

export const PERIODICIDAD_HONORARIOS = [
  { value: "mensual", label: "Mensual" },
  { value: "trimestral", label: "Trimestral" },
  { value: "anual", label: "Anual" },
];

// ----- Fase 2A: ejecución extrajudicial (Art. 403 LGTOC) -----
export const ETAPAS_EJECUCION = {
  solicitada: { label: "Solicitada", cls: "bg-slate-100 text-slate-700" },
  notificada: { label: "Notificada", cls: "bg-blue-100 text-blue-700" },
  en_oposicion: { label: "En oposición", cls: "bg-amber-100 text-amber-700" },
  suspendida: { label: "Suspendida", cls: "bg-slate-200 text-slate-600" },
  en_enajenacion: { label: "En enajenación", cls: "bg-orange-100 text-orange-700" },
  recursos_aplicados: { label: "Recursos aplicados", cls: "bg-indigo-100 text-indigo-700" },
  concluida: { label: "Concluida", cls: "bg-emerald-100 text-emerald-700" },
};
export const ORDEN_ETAPAS_EJECUCION = ["solicitada", "notificada", "en_oposicion", "en_enajenacion", "recursos_aplicados", "concluida"];
export const RESULTADOS_OPOSICION = [
  { value: "pago_total", label: "Pago total del crédito", evidencia: true },
  { value: "cumplimiento_acreditado", label: "Cumplimiento acreditado", evidencia: true },
  { value: "prorroga_novacion", label: "Prórroga / novación", evidencia: true },
  { value: "sin_oposicion", label: "Sin oposición (plazo vencido)", evidencia: false },
];

// ----- Fase 2B: libro contable fiduciario (Arts. 386 y 391 LGTOC) -----
export const TIPO_EVENTO_POLIZA = {
  aportacion_bien: "Aportación de bien",
  revaluacion: "Revaluación",
  sustitucion: "Sustitución",
  honorarios_devengados: "Honorarios devengados",
  gasto_conservacion: "Gasto de conservación",
  enajenacion: "Enajenación",
  aplicacion_recursos: "Aplicación de recursos",
  entrega_remanente: "Entrega de remanente",
  reversion: "Reversión / cierre",
  correccion: "Corrección",
};
export const TIPOS_POLIZA_MANUAL = ["gasto_conservacion", "correccion", "reversion"];

// ---------------- FASE 1B — Patrimonio + vínculos + aforo ----------------
export const TIPOS_BIEN = [
  { value: "inmueble", label: "Inmueble" },
  { value: "mueble", label: "Mueble" },
  { value: "derechos_credito", label: "Derechos de crédito" },
  { value: "acciones_partes_sociales", label: "Acciones / partes sociales" },
  { value: "dinero", label: "Dinero" },
  { value: "otro", label: "Otro" },
];
export const TIPO_BIEN_LABEL = Object.fromEntries(TIPOS_BIEN.map((t) => [t.value, t.label]));

export const POSESION_OPTIONS = [
  { value: "fiduciario", label: "Fiduciario (la entidad)" },
  { value: "fideicomitente", label: "Fideicomitente (depositario)" },
  { value: "tercero_depositario", label: "Tercero depositario" },
];
export const POSESION_LABEL = Object.fromEntries(POSESION_OPTIONS.map((p) => [p.value, p.label]));

export const ESTADOS_BIEN = {
  aportado: { label: "Aportado", cls: "bg-slate-100 text-slate-700" },
  en_patrimonio: { label: "En patrimonio", cls: "bg-emerald-100 text-emerald-700" },
  sustituido: { label: "Sustituido", cls: "bg-blue-100 text-blue-700" },
  liberado: { label: "Liberado", cls: "bg-slate-200 text-slate-600" },
  enajenado: { label: "Enajenado", cls: "bg-amber-100 text-amber-700" },
};
export const TRANSICIONES_BIEN = {
  aportado: ["en_patrimonio", "liberado"],
  en_patrimonio: ["liberado", "enajenado"],
};

export const TIPOS_VINCULO = [
  { value: "garantia_principal", label: "Garantía principal" },
  { value: "garantia_adicional", label: "Garantía adicional" },
];
export const TIPO_VINCULO_LABEL = Object.fromEntries(TIPOS_VINCULO.map((t) => [t.value, t.label]));

export const SEMAFORO_COBERTURA = {
  verde: { label: "Cobertura suficiente", cls: "bg-emerald-100 text-emerald-700", dot: "bg-emerald-500" },
  ambar: { label: "Bajo el aforo pactado", cls: "bg-amber-100 text-amber-700", dot: "bg-amber-500" },
  rojo: { label: "Cobertura insuficiente", cls: "bg-red-100 text-red-700", dot: "bg-red-500" },
};

export const fmtMoney = (v) => `$${Number(v || 0).toLocaleString("es-MX", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
